import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './../../utils/auth-context';

interface IProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: IProps) => {
  const { token, isCheckingSession } = useAuth();

  // Do not render protected UI while a token restored from browser storage
  // has not yet been verified by the API.
  if (isCheckingSession) {
    return <div role="status">Проверяем сессию…</div>;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
